import { EligibilityInterfaceV1 } from './EligibilityInterfaceV1';
import { EligibilityInterfaceType } from '@clientos/types';

export { createNoopEligibilityInterface } from './NoopInterface';

let eligibilityInterfaceV1: EligibilityInterfaceV1;

export function getEligibilityInterfaceV1(): EligibilityInterfaceType {
  return eligibilityInterfaceV1.getInterface();
}

export function clearEligibilityInterfaceSingleton(): void {
  eligibilityInterfaceV1 = undefined;
}

export async function initializeEligibilityInterfaceV1(): Promise<EligibilityInterfaceType> {
  if (eligibilityInterfaceV1) return eligibilityInterfaceV1.getInterface();

  eligibilityInterfaceV1 = new EligibilityInterfaceV1();

  return eligibilityInterfaceV1.getInterface();
}

// Keep backward compatibility
export default initializeEligibilityInterfaceV1;
